import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { eventsAPI } from '../api';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, ArrowRight } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const News = () => {
  const { settings } = useSettings();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Update title on mount
  useEffect(() => {
    document.title = `Haberler - ${settings.site_name || 'Cinefora'}`;
  }, [settings.site_name]);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      const response = await eventsAPI.getAll();
      setNews(response.data.filter(n => n.is_active));
    } catch (error) {
      console.error('Error loading news:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Haberler - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Sinema dünyasından en son haberler ve etkinlikler. Cinefora'da vizyona giren filmler hakkında güncel bilgiler." />
        <meta name="keywords" content="haberler, sinema haberleri, etkinlik, film haberleri, cinefora" />
      </Helmet>
      <Header />
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Haberler</h1>
        
        {loading ? (
          <p className="text-white text-center">Yükleniyor...</p>
        ) : news.length === 0 ? (
          <p className="text-gray-400 text-center">Henüz haber bulunmamaktadır.</p>
        ) : (
          <div className="space-y-6">
            {news.map((item) => (
              <Card key={item._id} className="bg-gradient-to-br from-purple-500/15 to-pink-500/15 border-purple-500/25 p-6 hover:border-pink-500/40 hover:from-purple-500/25 hover:to-pink-500/25 transition-all">
                <div className="flex gap-6">
                  <Link to={item.slug ? `/haberler/${item.slug}` : '#'} className="flex-shrink-0">
                    <img src={item.image} alt={item.title} className="w-48 h-32 object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity" />
                  </Link>
                  <div className="flex-1 flex flex-col">
                    <Link to={item.slug ? `/haberler/${item.slug}` : '#'}>
                      <h3 className="text-white font-bold text-2xl mb-3 hover:text-[#FDB714] transition-colors cursor-pointer">{item.title}</h3>
                    </Link>
                    <p className="text-gray-400 mb-4 line-clamp-2 flex-1">{item.description}</p>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-4 text-sm text-gray-500">
                        <div className="flex items-center gap-2">
                          <Calendar size={16} />
                          <span>{item.event_date}</span>
                        </div>
                        <span>{item.location}</span>
                      </div>
                      {item.slug && (
                        <Link to={`/haberler/${item.slug}`}>
                          <Button 
                            variant="ghost" 
                            size="sm"
                            className="text-[#FDB714] hover:text-white hover:bg-[#FDB714] transition-colors"
                          >
                            Devamını Oku
                            <ArrowRight size={16} className="ml-2" />
                          </Button>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default News;
